export function handleResize(grid, props) {
	return (e) => e.sender.resize();
}
